<div class="d-flex flex-column flex-md-row gap-md-3 mb-5">
  <div class="d-flex align-items-center gap-1">
    <span class="red-asterisk headline-20">* </span
    ><span class="font-size-sm">{{ 'inquiry.requiredBoth' | baseBusinessKey | translate }}</span>
  </div>
  <div class="d-flex align-items-center gap-1">
    <span class="orange-asterisk headline-20">* </span
    ><span class="font-size-sm">{{ 'inquiry.requiredPublish' | translate }}</span>
  </div>
</div>
<p
  class="font-red font-size-sm mb-5"
  *ngIf="form.hasError('invalidDutyData') && submitted"
>
  {{
    (form.value.flexShift ? 'validation.invalidFlexDutyData' : 'validation.invalidFixedDutyData')
      | baseBusinessKey
      | translate
  }}
</p>
<form
  [formGroup]="form"
  [ngClass]="{ 'was-validated': submitted }"
>
  <div
    class="overflow-modal-content"
    [ngStyle]="{ 'padding-bottom': requirementsOpen ? '26rem' : 0 }"
  >
    <div
      [formGroup]="form.controls.dates"
      class="d-flex flex-column flex-md-row align-items-lg-center mb-3"
    >
      <div class="col col-md-4">
        <label class="required fw-medium">{{ 'inquiry.period' | translate }}</label>
      </div>
      <div class="d-flex flex-column align-items-start gap-2">
        <div
          [formGroup]="form"
          class="d-flex gap-1 justify-content-start w-100"
        >
          <base-switch formControlName="unlimited"></base-switch>
          <span>{{ 'inquiry.unlimitedUntilMLP' | translate }}</span>
        </div>
        <base-range-datepicker
          *ngIf="!form.controls.unlimited.value"
          [isRequired]="true"
          formControlName="range"
          placement="bottom-left"
          [isInvalid]="!!form.controls.dates.controls.range.errors"
          [errorText]="form.controls.dates.controls.range.errors | baseFieldValidation"
          [minDate]="minDate"
          [readonly]="true"
        ></base-range-datepicker>
        <div
          [formGroup]="form"
          class="d-flex flex-column flex-lg-row gap-3 align-items-lg-center"
          *ngIf="form.controls.unlimited.value"
        >
          <div class="d-flex flex-no-wrap align-items-center gap-2">
            <span>{{ 'from_' | translate }}</span>
            <base-datepicker
              *ngIf="form.contains('startDate')"
              [minDate]="minDate"
              formControlName="startDate"
              [isInvalid]="!!form.controls.startDate?.errors"
              [errorText]="form.controls.startDate?.errors | baseFieldValidation"
              [readonly]="true"
            ></base-datepicker>
          </div>
          <div class="d-flex flex-no-wrap align-items-center gap-2">
            <span>{{ 'inquiry.until' | translate }}</span>
            <span>{{ form.controls.dates.controls.range.value.to | date: 'dd.MM.yyyy' }}</span>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="d-flex flex-column flex-md-row align-items-lg-center mb-3">
      <div class="col col-md-4">
        <label class="required fw-medium">{{ 'department.singular' | translate }}</label>
      </div>
      <div class="col d-flex flex-column gap-2">
        <base-dropdown
          class="col"
          [ngClass]="{ 'department-dropdown': form.value.customerDepartment }"
          [items]="departments"
          [requiredLabel]="true"
          [customLayout]="true"
          searchProperty="primaryData.name,location.name"
          bindOptionLabel="primaryData.name"
          bindOptionSubLabel="location.name"
          formControlName="customerDepartment"
          placeholder="placeholders.selectDepartment"
          baseFieldValidationArgs="selectDepartment"
          placement="bottom"
        ></base-dropdown>

        <p
          class="font-size-sm text-danger"
          *ngIf="!departments?.length && isCustomerAdmin"
        >
          {{ 'noDepartmentsCreatedPleaseSwitch' | translate }}
          <a
            class="text-link"
            (click)="redirectToManageOrganisation()"
          >
            {{ 'locationManagement' | translate }}
          </a>
          {{ 'noDepartmentsToCreateThem' | translate }}<br />
          {{ 'noDepartmentsCreationRequired' | translate }}
        </p>
      </div>
    </div>
    <hr />
    <div class="d-flex flex-column flex-md-row align-items-lg-center mb-3">
      <div class="col col-md-4">
        <label class="required fw-medium">{{ 'contactPerson' | translate }}</label>
      </div>
      <div class="col d-flex flex-column gap-2">
        <base-dropdown
          class="col"
          [items]="users"
          [searchable]="false"
          [requiredLabel]="true"
          bindOptionLabel="fullName"
          bindOptionValue="party"
          formControlName="responsible"
          [requiredAnother]="['fillInDepartmentFirst', !form.value.customerDepartment]"
          baseFieldValidationArgs="selectResponsible"
          placeholder="placeholders.selectContactPerson"
          placement="bottom"
        ></base-dropdown>
        <p
          class="font-size-sm text-danger"
          *ngIf="!users?.length && form.value.customerDepartment && !isResponsibleLoading && isCustomerAdmin"
        >
          {{ 'noContactPersonsFound1' | translate }}
          <a
            class="text-link"
            (click)="redirectToManageOrganisation()"
          >
            {{ 'locationManagement' | translate }}
          </a>
          {{ 'noContactPersonsFound2' | translate }}
        </p>
      </div>
    </div>
    <hr />
    <div class="d-flex flex-column flex-md-row align-items-lg-center mb-3">
      <div class="col col-md-4">
        <label class="required fw-medium">{{ 'qualifications.primaryJob' | translate }}</label>
      </div>
      <base-dropdown
        class="col col-lg-8"
        [items]="qualifications"
        formControlName="mainQualification"
        [requiredLabel]="true"
        [requiredAnother]="['fillInDepartmentFirst', !form.value.customerDepartment]"
        [markFavourites]="true"
        baseFieldValidationArgs="selectPrimaryJob"
        placeholder="placeholders.selectPrimaryJob"
        placement="bottom"
      ></base-dropdown>
    </div>
    <hr />
    <div class="d-flex flex-column flex-md-row align-items-lg-center mb-3">
      <div class="col col-md-4">
        <label class="mt-2 fw-medium">{{ 'qualifications.secondaryJob' | translate }}</label>
      </div>
      <base-dropdown
        class="col"
        [items]="filteredQualifications"
        formControlName="qualifications"
        [requiredAnother]="['fillInDepartmentFirst', !form.value.customerDepartment]"
        baseFieldValidationArgs="selectResponsible"
        placeholder="placeholders.selectSecondaryJob"
        outputModel="id"
        placement="bottom"
        [multiple]="true"
        [markFavourites]="true"
      ></base-dropdown>
    </div>
    <hr />
    <div class="d-flex flex-column flex-md-row align-items-lg-center mb-3">
      <div class="col col-md-4">
        <label class="required fw-medium">{{ 'jobDescription' | translate }}</label>
      </div>
      <div class="d-flex flex-column gap-2 w-100">
        <base-textarea
          placeholder="placeholders.jobDescription"
          class="col"
          formControlName="jobDescription"
          [isInvalid]="!!form.controls.jobDescription.errors"
          [errorMessage]="
            form.controls.jobDescription.errors | baseFieldValidation: { required: 'selectJobDescription' }
          "
          [autoGrowEnabled]="true"
        ></base-textarea>
        <base-button
          [disabled]="
            modifiedJobDescriptionValue === undefined ||
            form.getRawValue().mainQualification?.description === '' ||
            form.getRawValue().jobDescription === form.getRawValue().mainQualification?.description
          "
          class="d-block"
          color="secondary"
          label="inquiry.loadJobDescriptionBtn"
          [size]="buttonSize.xs"
          (btnClick)="setFromQualification()"
        ></base-button>
      </div>
    </div>
    <hr />
    <div class="d-flex flex-column flex-md-row align-items-lg-center mb-3">
      <div class="col col-md-4">
        <label class="fw-medium">{{ 'conditions' | translate }}</label>
      </div>
      <div class="col-4 d-flex align-items-center">
        <base-input
          formControlName="weeklyWorkingHours"
          step="1"
          type="number"
          [min]="0"
          [classList]="['me-3']"
          class="col"
        ></base-input>
        <span>{{ 'work.hoursPerWeek' | translate }}</span>
      </div>
    </div>
    <hr />
    <div class="d-flex flex-column flex-md-row align-items-lg-center mb-3">
      <div class="col col-md-4">
        <label class="fw-medium">{{ 'work.shift.selection' | baseBusinessKey | translate }}</label>
      </div>
      <div class="col d-flex flex-column gap-2">
        <div class="d-flex">
          <span class="me-2">{{ 'work.shift.flexible' | baseBusinessKey | translate }}</span>
          <base-switch
            [isDisabled]="form.controls.unlimited.value"
            [ngbTooltip]="form.controls.unlimited.value ? ('inquiry.onlyFlexible' | translate) : undefined"
            formControlName="flexShift"
            color="primary"
            [reverseValue]="true"
          ></base-switch>
          <span class="ms-1">{{ 'work.shift.fixed' | baseBusinessKey | translate }}</span>
        </div>
        <base-button
          color="secondary"
          [size]="buttonSize.xs"
          [label]="'action.editShiftTimes' | baseBusinessKey"
          (btnClick)="openEditTimeShiftsModal()"
        ></base-button>
      </div>
    </div>

    <hr />

    <base-customer-weekdays-and-shifts
      [form]="form"
      [submitted]="submitted"
      [flexShift]="!!form.value.flexShift"
    ></base-customer-weekdays-and-shifts>

    <ng-container *ngIf="!form.value.flexShift">
      <div
        class="d-flex flex-column flex-md-row align-items-lg-center"
        formGroupName="shiftsAndPersons"
      >
        <div class="col col-md-4">
          <label class="required-alt fw-medium">{{ 'work.shift.persons' | baseBusinessKey | translate }}</label>
        </div>
        <div
          formGroupName="persons"
          class="col d-flex flex-column gap-2"
        >
          <ng-container *ngFor="let shift of timeShiftsForm.getRawValue(); trackBy: trackByShift">
            <div class="row align-items-center">
              <i
                class="col-1 fa-regular"
                [ngClass]="baseShiftIconsEnum[shift.type]"
              ></i>
              <span class="col-7">{{
                ('externalEmployees.masterData.shiftReadiness.' + shift.type | baseBusinessKey | translate) +
                  ' (' +
                  shift.startTime +
                  ' - ' +
                  shift.endTime +
                  ')'
              }}</span>
              <base-input-number
                class="col"
                [formControlName]="shift.type + 'Persons'"
              ></base-input-number>
            </div>
          </ng-container>
          <span
            class="font-red font-size-sm"
            *ngIf="form.controls.shiftsAndPersons.controls.persons.hasError('invalidShiftPersons')"
            >{{ 'validation.atLeastOnePerson' | baseBusinessKey | translate }}</span
          >
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="form.value.flexShift">
      <div
        formGroupName="shiftsAndPersons"
        class="d-flex flex-column flex-md-row align-items-lg-center mb-3"
      >
        <div class="col col-md-4">
          <label class="required-alt fw-medium">{{ 'inquiry.amountPersons' | translate }}</label>
        </div>
        <base-input-number
          class="col"
          formControlName="amountPersons"
          [min]="1"
        ></base-input-number>
      </div>
    </ng-container>

    <hr />

    <div class="d-flex flex-column flex-md-row align-items-lg-center mb-3">
      <div class="col col-md-4">
        <label class="mt-2 fw-medium">{{ 'costUnit' | translate }}</label>
      </div>
      <base-input
        formControlName="costUnit"
        class="col"
        [isInvalid]="!!form.controls.costUnit.errors"
        [errorMessage]="
          form.controls.costUnit.errors?.maxLength
            ? 'validation.maxLength'
            : (form.controls.costUnit.errors | baseFieldValidation)
        "
      ></base-input>
    </div>
    <hr />
    <div class="d-flex flex-column flex-md-row align-items-lg-center mb-3">
      <div class="col col-md-4 d-flex flex-column">
        <label class="d-block mt-2 fw-medium mb-0">{{ 'workEquipment' | translate }}</label>
        <span class="fs-8">{{ 'providedByMe' | translate }}</span>
      </div>
      <base-input
        formControlName="workEquipmentCustomer"
        class="col"
        [isInvalid]="!!form.controls.workEquipmentCustomer.errors"
        [errorMessage]="
          form.controls.workEquipmentCustomer.errors?.maxLength
            ? 'validation.maxLength'
            : (form.controls.workEquipmentCustomer.errors | baseFieldValidation)
        "
      ></base-input>
    </div>
    <hr />
    <div class="d-flex flex-column flex-md-row align-items-lg-center mb-3">
      <div class="col col-md-4 d-flex flex-column">
        <label class="d-block mt-2 fw-medium mb-0">{{ 'workEquipment' | translate }}</label>
        <span class="fs-8">{{ 'providedByServiceProvider' | translate }}</span>
      </div>
      <base-input
        formControlName="workEquipmentPsp"
        class="col"
        [isInvalid]="!!form.controls.workEquipmentPsp.errors"
        [errorMessage]="
          form.controls.workEquipmentPsp.errors?.maxLength
            ? 'validation.maxLength'
            : (form.controls.workEquipmentPsp.errors | baseFieldValidation)
        "
      ></base-input>
    </div>
    <hr />
    <div class="d-flex flex-column flex-md-row align-items-lg-center mb-3">
      <div class="col col-md-4">
        <label class="mt-2 fw-medium">{{ 'work.conditions.alt' | translate }}</label>
      </div>
      <base-dropdown
        class="col"
        placement="top"
        [items]="filteredRequirements"
        formControlName="requirements"
        placeholder="placeholders.selectRequirements"
        outputModel="id"
        [multiple]="true"
      ></base-dropdown>
    </div>
    <hr />
    <div class="d-flex flex-column flex-md-row align-items-lg-center mb-3">
      <div class="col col-md-4">
        <label class="fw-medium">{{ 'inquiry.remark' | translate }}</label>
      </div>
      <base-textarea
        placeholder="placeholders.remark"
        class="col"
        formControlName="remark"
      ></base-textarea>
    </div>
    <hr />
    <div class="d-flex flex-column flex-md-row align-items-lg-center mb-3">
      <div class="col col-md-4">
        <label class="fw-medium">{{ 'document.singular' | translate }}</label>
      </div>
      <div class="w-100">
        <base-customer-inquiry-document></base-customer-inquiry-document>
      </div>
    </div>
    <span
      class="mt-6 pointer text-decoration-underline"
      (click)="clearStaffRequestForm()"
    >
      {{ 'deleteFormdata' | translate }}
    </span>
  </div>
  <div class="modal-footer edge-footer px-0">
    <base-button
      color="secondary"
      [size]="buttonSize.md"
      label="action.cancel"
      (click)="modalRef.dismiss()"
      [attr.data-cy]="'action.cancel'"
    >
    </base-button>
    <div class="create-staff-request-buttons">
      <base-button
        class="save-staff-request-button"
        color="dark"
        icon="fa-solid fa-floppy-disk"
        [iconSize]="buttonSize.lg"
        baseScrollToInvalid
        [baseInvalidFormSubmitted]="submitted"
        [baseInvalidForm]="form"
        (btnClick)="checkValidationForPublish(true)"
      ></base-button>
      <base-button
        class="btn-confirm d-none d-md-block"
        color="primary"
        [ngbTooltip]="form.controls.unlimited.value ? ('inquiry.viewNotAvailable' | translate) : undefined"
        [disabled]="form.controls.unlimited.value"
        [size]="buttonSize.md"
        [label]="'work.shift.view' | baseBusinessKey"
        (btnClick)="checkValidationForShiftView()"
        baseScrollToInvalid
        [baseInvalidFormSubmitted]="submitted"
        [baseInvalidForm]="form"
        [attr.data-cy]="'modal.button.secondaryAction'"
      ></base-button>
      <base-button
        *ngIf="canPublishInquiry"
        class="btn-confirm"
        color="primary"
        [size]="buttonSize.md"
        label="action.publish"
        (btnClick)="checkValidationForPublish()"
        baseScrollToInvalid
        [baseInvalidFormSubmitted]="submitted"
        [baseInvalidForm]="form"
        [attr.data-cy]="'modal.button.ok'"
      ></base-button>
    </div>
  </div>
</form>

<ng-template #editTimeShifts>
  <base-customer-edit-shift-view-modal
    [parentForm]="form"
    [modalRef]="timeShiftsModalRef"
  ></base-customer-edit-shift-view-modal>
</ng-template>

<ng-template #serviceProviderSelectModal>
  <base-customer-service-provider-select-modal
    [modalRef]="inquiryVisibilityAndNotificationsModalRef"
    [isInquiryDefaultFilter]="isInquiryDefaultFilter"
    [isOpenFromStaffRequestModal]="true"
    [inquiryId]="createdInquiryId"
  ></base-customer-service-provider-select-modal>
</ng-template>
